export default __webpack_public_path__ + "static/media/how-3b@2x.4329308c.png";